// Imports
// ------
import React from 'react';
import styled, { css } from 'styled-components';
import { breakup } from '@break';
import { Div, P } from '@reuse';

// Styles
// ------
const sharedMargin = css`
    margin-bottom: 3.6rem;

    ${breakup.large` margin-bottom: 4.8rem; `}
`;

const LegalInformation = styled(Div)`
    ${sharedMargin}

    ${P} {
        &:nth-child(2) {
            margin-top: 3.6rem;

            ${breakup.large`
                margin-top: 4.8rem;
            `}
        }
    }
`;


const Copyright = styled(Div)`
    ${sharedMargin}

    p { display: inline-block; }
`;

const Link = styled.a`
    transition: all .25s ease-in-out;
    display: inline-block;

    span { font-weight: bold; }

    &:hover {
        opacity: 0.5;
    }
`;

// Component
// ------
export default class Content extends React.PureComponent {
    render() {
        const date = (new Date().getFullYear())
        return (
            <>
                <LegalInformation mpad>
                    <P>We are authorised and regulated by the Financial Conduct Authority. Registration no. 307051.</P>
                    <P small>Our Address: 34 Stoops Rd, Doncaster DN4 7ES</P>
                </LegalInformation>

                <Copyright mpad>
                    <P>Mortgage Remortgages &copy; {date}.&nbsp;</P>
                    <P>
                        <Link href="http://12studio.agency" target="_blank">Site by <span>12</span></Link>
                    </P>
                </Copyright>
            </>
        );
    }
}
